import { axiosApiInstance } from "@/libs/axios";
import { API_ENDPOINTS } from "@/constants/api";

export interface CreateInvitationRequest {
  type: "ONE_TIME" | "UNLIMITED" | "EMAIL";
  description?: string;
  user_ids?: string[];
}

export interface CreateInvitationResponse {
  invitation_id: string;
}

export const createInvitation = async (
  data: CreateInvitationRequest,
): Promise<CreateInvitationResponse> => {
  const response = await axiosApiInstance.post(API_ENDPOINTS.WORKSPACES.INVITATIONS.CREATE, data);

  return response.data;
};
